export default __webpack_public_path__ + "static/media/CurrencyKidzLogo.5ee9f333.png";